<template>
    <div class="footer">
        <hr>
        <div class="msg-content">
<!--            <div>-->
<!--                <h1>产品及服务</h1>-->
<!--                <p>我们的优势</p>-->
<!--                <p>广告形式</p>-->
<!--            </div>-->
            <div class="phone">
                <h1>电话&微信</h1>
                <p>177-2473-1490</p>
                <p>ptb202188</p>
            </div>
            <div class="email">
                <h1>联系邮箱</h1>
                <p>wlh@paotuanbang.cn</p>
                <p>jn@paotuanbang.cn</p>
            </div>
            <div>
                <h1>新浪微博</h1>
                <img src="../assets/images/weibo_qr.png">
            </div>
            <div>
                <h1>公众号</h1>
                <img src="../assets/images/wechat_qr.png">
            </div>
            <div>
                <h1>抖音号</h1>
                <img src="../assets/images/douyin_qr.jpg">
            </div>
            <div>
                <h1>小程序</h1>
                <img src="../assets/images/wtchat_mp_qr.png">
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style scoped lang="stylus">
    .footer
        width: 84%
        max-width: 1200px;
        margin: 0 auto
        padding-bottom: 70px

        hr
            /*width: 1114px*/
            border: 3px solid #e5e5e5
            margin: 0 auto
            margin-top: 88px

        .msg-content
            margin-top: 60px
            display: flex
            justify-content center
            width: 100%
            .phone
                width 150px
            .email
                width 150px
            div
                display: flex
                flex-wrap wrap
                justify-content center
                align-items start
                width: 120px
                h1
                    font-size: 23px
                    font-weight: 400
                p
                    font-size: 18px
                    color: #848484;
                img
                    display: inline-block
                    width: 136px

            div + div
                margin-left: 60px
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue